import { render, staticRenderFns } from "./planningSpectaculars.vue?vue&type=template&id=fb084a08&scoped=true"
import script from "./planningSpectaculars.vue?vue&type=script&lang=js"
export * from "./planningSpectaculars.vue?vue&type=script&lang=js"
import style0 from "./planningSpectaculars.vue?vue&type=style&index=0&id=fb084a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb084a08",
  null
  
)

export default component.exports